module.exports = __webpack_public_path__ + "static/media/bootstrap-magazin-min.a81cb7ac.png";